import React from 'react';

const ResetMap: React.FC = () => {
  return (
    <svg
      height="24px"
      width="24px"
      viewBox="0 0 25 24"
      style={{
        fill: '#4b585d',
      }}
    >
      <path d="M18 4c1.093 0 1.981.877 2 1.966V18c0 1.093-.877 1.981-1.966 2H6c-1.093 0-1.981-.877-2-1.966V6c0-1.093.877-1.981 1.966-2H18zm0 1.2H6c-.433 0-.786.345-.8.775V18c0 .433.345.786.775.8H18c.433 0 .786-.345.8-.775V6c0-.433-.345-.786-.775-.8H18zm-5.6 9.6c.442 0 .8.358.8.8v.8c0 .442-.358.8-.8.8h-.8c-.442 0-.8-.358-.8-.8v-.8c0-.442.358-.8.8-.8h.8zm-4.1-4c.442 0 .8.358.8.8v.8c0 .442-.358.8-.8.8h-.8c-.442 0-.8-.358-.8-.8v-.8c0-.442.358-.8.8-.8h.8zm4.1 0c.442 0 .8.358.8.8v.8c0 .442-.358.8-.8.8h-.8c-.442 0-.8-.358-.8-.8v-.8c0-.442.358-.8.8-.8h.8zm4.1 0c.442 0 .8.358.8.8v.8c0 .442-.358.8-.8.8h-.8c-.442 0-.8-.358-.8-.8v-.8c0-.442.358-.8.8-.8h.8zm-4.1-4c.442 0 .8.358.8.8v.8c0 .442-.358.8-.8.8h-.8c-.442 0-.8-.358-.8-.8v-.8c0-.442.358-.8.8-.8h.8z" />
    </svg>
  );
};

export default ResetMap;
